import React from "react";
// import { withRouter } from "react-router";
import decode from "jwt-decode";
const AuthContext = React.createContext();
/**
 *  Login Authentication Provider
 */
class AuthProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuth: false,
    };
  }

  login = () => {
    const { exp } = decode(localStorage.getItem("token"));
    console.log(Date.now());
    console.log(exp * 1000);
    if (Date.now() >= exp * 1000) {
      alert("your session is expired.Please login again");
      this.props.history.push("/login");
    }
    if (localStorage.getItem("token") !== null) {
      this.setState({ isAuth: true });
    } else {
      this.setState({ isAuth: false });
    }
    //  this.props.history.push("/")
  };

  logout = () => {
    localStorage.removeItem("token");
    this.setState({ isAuth: false });
    this.props.history.push("/");
  };

  render() {
    return (
      <AuthContext.Provider
        value={{
          isAuth: this.state.isAuth,
          login: this.login,
          logout: this.logout,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

const AuthConsumer = AuthContext.Consumer;
const AuthProviderWithRouter = AuthProvider

export { AuthProviderWithRouter as AuthProvider, AuthConsumer };
